// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const dialogClasses = {
  backdrop: "qui-dialog__backdrop",
  body: "qui-dialog__body",
  closeButton: "qui-dialog__close-button",
  content: "qui-dialog__content",
  footer: "qui-dialog__footer",
  heading: "qui-dialog__heading",
  indicatorIcon: "qui-dialog__indicator-icon",
  positioner: "qui-dialog__positioner",
} as const
